export default {
  title: {
    fontFamily: 'NotoSansKR, SackersGothicStd, sans-serif',
    fontSize: '62px',
    fontWeight: 400,
    'screen-large': {
      fontSize: '62px',
      lineHeight: '60px',
    }
  },
  preTitle: {
    fontFamily: 'NotoSansKR, SackersGothicStd, sans-serif',
    fontSize: '19px',
    lineHeight: '25px',
    fontWeight: 400,
    'screen-large': {
      fontSize: '30px',
      lineHeight: '40px',
    }
  },
  contentContainerStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 16px',
    'screen-large': {
      padding: '32px 112px'
    }
  },
  additionalBackgroundPictureStyles: {
    height: '260px',
    'screen-large': {
      height: '292px'
    }
  }
}
